import React from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { GetServerSidePropsContext } from 'next'

import runMiddleware from 'lib/middleware'
import { initializeApollo, addApolloState } from 'lib/apolloClient'

import MarketingWholesalerPageContent from 'modules/website/components/MarketingWholesalerPageContent'

import GET_FIELDFOLIO_RECURRING_PLAN_DETAILS from 'hooks/graphql/GetFieldfolioRecurringPlanDetails.graphql'

const WholesalerPage = () => (
  <>
    <Head>
      <title>Sell wholesale online · Fieldfolio</title>
      <meta name="description" content="Australia's best wholesale platform. Sell in the field and online." />
      <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/wholesaler`} />
      {process.env.NEXT_PUBLIC_GOOGLE_OPTIMIZE_ID && (
        <Script
          src={`https://www.googleoptimize.com/optimize.js?id=${process.env.NEXT_PUBLIC_GOOGLE_OPTIMIZE_ID}`}></Script>
      )}
    </Head>
    <MarketingWholesalerPageContent />
  </>
)

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  runMiddleware(ctx)

  const apolloClient = initializeApollo()

  await apolloClient.query({
    query: GET_FIELDFOLIO_RECURRING_PLAN_DETAILS
  })

  return addApolloState(apolloClient, { props: {} })
}

export default WholesalerPage
